/**
 * The types supported by the validator library.
 */
export var Type;
(function (Type) {
    Type["Array"] = "Array";
    Type["Boolean"] = "boolean";
    Type["Date"] = "Date";
    Type["Error"] = "Error";
    Type["Function"] = "Function";
    Type["Map"] = "Map";
    Type["Null"] = "null";
    Type["Number"] = "number";
    Type["Object"] = "object";
    Type["Promise"] = "Promise";
    Type["Set"] = "Set";
    Type["String"] = "string";
    Type["Symbol"] = "Symbol";
    Type["RegExp"] = "RegExp";
    Type["Undefined"] = "undefined";
    Type["WeakMap"] = "WeakMap";
    Type["WeakSet"] = "WeakSet";
})(Type || (Type = {}));
//# sourceMappingURL=type.js.map